import React from 'react';

const ExtraSectionSecond = () => {
    return (
        <div className='container mt-5'>
               <div className='row'>
  <div className='col-sm-12 col-lg-5 mt2 bestbike '>
        <h3>Top   seling  bike in our warehouse</h3>
        <p>
            This bike name yamaha 44sc .. This bike choice everbody  so preson buying
            This bike ... this bike top selling in this year.Do you buying this bike booking now

        </p>
           </div>
        <div className='col-sm-12 col-lg-7 div mt-5'>
      <img className='img' src=" https://i.ibb.co/gT8zqHd/black-motorcycle-white.png " alt="" />
  </div>
  </div>

</div>
     
    );
};

export default ExtraSectionSecond;